import { useEffect, useState } from 'react';
import Menu from './Compartido/Menu.jsx';
import Footer from './Compartido/Footer.jsx';
import ContenidoHtml from './Compartido/ContenidoHtml.jsx';
import { useTranslation } from 'react-i18next';
import htmlHabitaciones from './PaginaInterna/Habitaciones.jsx';
import { RUTA_IMATGES } from './Compartido/contenidoCamprodon.js';

// Pàgines internes de l'Hotel Camprodon (Hotel, Habitacions, Restaurant,
// Esdeveniments...): PaginasController::paginaHotelCamprodon passa l'HTML
// de Contenido/{idioma}/{pagina}.html a `contenidohtml`.
const PaginaInterna = (props) => {

    const { t } = useTranslation();

    var preidioma = "";
    if (props.lang != 'es') preidioma = props.lang + "/";

    // Habitacions: les propietats destacades, a continuació del contingut.
    const html = props.pagina === 'habitaciones'
        ? props.contenidohtml + htmlHabitaciones(props.habitaciones, props.ruta, props.lang,
            (propiedad) => "/" + preidioma + t("apartamentos") + "-" + propiedad.url_destino + "/" + propiedad.url_dinamica)
        : props.contenidohtml;

    const [mostraTornar, setMostraTornar] = useState(false);

    useEffect(() => {
        const alFerScroll = () => setMostraTornar(window.scrollY > window.innerHeight);
        window.addEventListener('scroll', alFerScroll, { passive: true });
        return () => window.removeEventListener('scroll', alFerScroll);
    }, []);

    return (
        <main className={"hc hc-pagina hc-pagina--" + props.pagina}>
            <Menu
                destinos={props.destinos}
                sobrenosotros={props.textosobrenosotros}
                clientes={props.textoclientes}
                propietarios={props.textopropietarios}
                servicios={props.textoservicios}
                experiencias={props.experiencias}
                idiomas={props.idiomas}
                lang={props.lang}
                tiposcasas={props.tiposcasas}
                config={props.websgrupo}
                textopropiedades={props.textopropiedades}
                edificios={props.edificios}
                marcas={props.marcas}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                numblog={props.numblog}
                numfaqs={props.numfaqs}
                paginapersonalizada={props.paginapersonalizada}
                transparente={true}
            />

            <ContenidoHtml html={html} titulo={props.meta_titulo} />

            <Footer
                datos={props.websgrupo}
                terminos={props.textoterminos}
                protocolos={props.textoprotocolos}
                avisolegal={props.textoavisolegal}
                politicaprivacidad={props.textopolitica}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
                numfaqs={props.numfaqs}
                senseNewsletter={props.pagina === 'newsletter'}
            />
            <div className="hc-sticky-spacer"></div>

            <button
                type="button"
                className={"c-back-to-top" + (mostraTornar ? " is-visible" : "")}
                aria-label="Back to top"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
                <svg aria-hidden="true" focusable="false" className="c-icon" width="48" height="48">
                    <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-back-to-top"}></use>
                </svg>
            </button>
        </main>
    );
}

export default PaginaInterna;
